import request from '@/utils/request'

export function getLoginResult(data) {
    return request({
        url: '/wechat/getLoginResult',
        method: 'get',
        params: data
    })
}
